import config from "@/config"
import http from "@/utils/request"

export default {
	getList: {
		url: `${config.API_URL}/generate/getList`,
		name: "创作列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},
	save: {
		url: `${config.API_URL}/generate/save`,   //task_type 1 普通  2 智能
		name: "新增普通创作",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},
	getConfig: {
		url: `${config.API_URL}/template/getConfig`,
		name: "获取模板剪辑配置信息",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},

	delete: {
		url: `${config.API_URL}/generate/delete`,
		name: "删除普通和智能创作",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},

	changeName: {
		url: `${config.API_URL}/generate/changeName`,
		name: "修改作品名称",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},

	userRetry: {
		url: `${config.API_URL}/generate/userRetry`,
		name: "重试",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},

	randArticle: {
		url: `${config.API_URL}/generate/randArticle`,
		name: "随机文案",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},
}
